import { totalEngagementConfig } from '@/lib/analytics/kpis/instagram/totalEngagement';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const totalEngagementsMVConfig = {
    ...totalEngagementConfig,
    id: 'engagements',
    name: 'kpi.instagram.total_engagement',
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
